import { useMemo } from 'react';
import { useGetGlobalSearchQuery } from 'src/api/redux';
import type { GlobalSearchProvider } from 'src/api/redux/globalSearch/globalSearchApi';

const EMPTY_RESULTS: GlobalSearchProvider[] = [];

/**
 * Hook to perform global search using RTK Query
 * @param searchTerm - The search term to query
 * @returns `isLoading` is true only for the first request; `isFetching` is true
 * for every in-flight request, including later search terms
 */
const useGlobalSearch = (searchTerm: string) => {
  const { data, error, isLoading, isFetching } = useGetGlobalSearchQuery(
    searchTerm,
    {
      skip: !searchTerm || searchTerm.length <= 2,
    }
  );

  return useMemo(
    () => ({
      data: data ?? EMPTY_RESULTS,
      error,
      isLoading,
      isFetching,
    }),
    [data, error, isLoading, isFetching]
  );
};

export default useGlobalSearch;
